import termQuery from "./termQuery"
import yearQuery from "./yearQuery"

export default {
    termQuery ,
    yearQuery
}